<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      title="渲染计划"
      :innerHeight="500"
      width="810px"
      :showFooter="activeName == 0"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
    >
      <el-tabs v-model="activeName">
        <el-tab-pane label="渲染计划" name="0"></el-tab-pane>
        <el-tab-pane label="渲染类型" name="1"></el-tab-pane>
      </el-tabs>
      <div v-if="activeName == 0">
        <!-- // 业务 -->
        <div v-for="(item, index) in skuList" :key="index" class="sku-item">
          <div class="sku-item-header">
            <el-row :gutter="10">
              <el-col :span="6">SKU编码：{{ item.skuCode }}</el-col>
              <el-col :span="11">SKU名称：{{ item.skuName }}</el-col>
              <el-col :span="7" style="text-align: right">
                <div v-if="activeSku && relationSku.indexOf(item.skuCode) > -1">
                  <span>已关联：</span>
                  <el-tag type="primary" closable size="small" @close="handleTagClose(item.skuCode)">{{ activeSku }}</el-tag>
                </div>
                <div v-else-if="skuList.length > 1" class="same-plan-box">
                  <el-select
                    size="mini"
                    v-model="item.selectedSku"
                    multiple
                    collapse-tags
                    placeholder="请选择"
                    :disabled="item.isRenderStart == 1 || disabledType"
                    @focus="getSkuOptions(item)"
                    @change="getSkuChange(item)"
                  >
                    <el-option v-show="!all" label="全部" value=""></el-option>
                    <el-option v-show="all" label="取消所有" value="cancleAll"></el-option>
                    <el-option v-for="item in skuOptions" :key="item.skuCode" :label="item.skuCode" :value="item.skuCode"> </el-option>
                  </el-select>
                  <el-button type="primary" size="small" plain @click="relationWithSku(item)">同计划</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="sku-item-form">
            <div class="relation-sku" v-if="activeSku === item.skuCode">
              <el-tag type="primary" v-for="(relatedCode, index) in relationSku" :key="index" closable size="small" @close="handleTagClose(relatedCode)">{{
                relatedCode
              }}</el-tag>
            </div>
            <el-form :model="item.form1" :inline="true" size="small" :disabled="item.isRenderStart == 1 || relationSku.indexOf(item.skuCode) > -1">
              <el-tag type="warning" size="mini" class="form-tag">渲染</el-tag>
              <el-form-item label="计划结束：">
                <el-date-picker v-model="item.form1.planEndTime" :picker-options="pickerOptions" type="date" placeholder="选择日期"> </el-date-picker>
              </el-form-item>
              <el-form-item label="计划人员：">
                <el-select v-model="item.form1.planPersonId" filterable="" placeholder="请选择">
                  <el-option
                    v-for="item in userList"
                    :key="item.userId"
                    :label="`${item.userName}${item.workNo ? '-' + item.workNo : ''}`"
                    :value="item.userId"
                  >
                  </el-option>
                </el-select>
                <!-- <el-input v-model.trim="item.form1.planPerson"></el-input> -->
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="tips">提示：每个SKU的计划必须要完整填写，才能够继续。<span>如有遗漏则该SKU无法进入下一步！</span></div>
      </div>
      <div v-else>
        <div style="text-align: left; margin-bottom: 10px">
          <el-button
            :type="editStatus ? 'warning' : 'primary'"
            size="small"
            v-permission="`ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$renderingTypeEditing`"
            @click="edit"
            style="margin: 10px 0"
            >{{ editStatus ? '保存' : '编辑' }}</el-button
          >
          <el-button :type="'primary'" size="small" style="margin: 10px 0" @click="cancel" v-if="editStatus">取消</el-button>
        </div>
        <el-table :data="tableData" border height="360px" :span-method="objectSpanMethod">
          <el-table-column prop="skuCode" label="SKU编码"> </el-table-column>
          <el-table-column prop="skuName" label="SKU名称"> </el-table-column>
          <el-table-column prop="productCode" label="产品编码"> </el-table-column>
          <el-table-column prop="productName" label="产品名称"> </el-table-column>
          <el-table-column prop="normalProductNum" label="常规产品">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.normalProductNum"
                @input="scope.row.normalProductNum = scope.row.normalProductNum.replace(/^0+(\d)|[^\d]+/g, '')"
                v-if="editStatus"
              ></el-input>
              <span v-else>{{ scope.row.normalProductNum }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </q-dialog>
  </div>
</template>

<script>
import axios from '@/utils/axiosInstance';
import moment from 'moment';

export default {
  model: {
    prop: 'visible',
    event: 'input',
  },
  props: ['visible', 'spuCode', 'spuId'],
  data() {
    const ONE_DAY_MILLSECONDS = 24 * 60 * 60 * 1000;
    return {
      dialogVisible: false,
      // 业务
      skuList: [],
      form: {},
      activeSku: '',
      relationSku: [],
      loading: false,
      spuInfo: {},
      selectedSku: [],
      tableData: [],
      skuOptions: [],
      all: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - ONE_DAY_MILLSECONDS;
        },
      },
      userList: [],
      activeName: 0,
      editStatus: false,
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: '',
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: '',
        hasCount: 'N',
        groupAttr: '',
      },
      spanArr: [],
      spanIndex: 0,
    };
  },
  computed: {
    disabledType() {
      return this.skuList.length - this.skuList.filter((v) => v.isRenderStart == 1).length <= 1;
    },
  },
  mounted() {
    this.dialogVisible = this.visible;
    this.getSpuInfo();
    this.getUserList();
    this.init2();
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      setTimeout((_) => {
        this.$emit('input', false);
      }, 200);
    },
    getSkuChange(spu) {
      if (spu.selectedSku.includes('')) {
        spu.selectedSku = this.skuOptions.map((v) => v.skuCode);
        this.all = true;
      } else if (spu.selectedSku.includes('cancleAll')) {
        spu.selectedSku = [];
        this.all = false;
      }
    },
    checkValid() {
      // const validSku = this.skuList.some(item => {
      //   const {form1} = item;
      //   return !!form1.planStartTime && !!form1.planEndTime && form1.planPerson
      // })
      let validSku = [];
      this.skuList.forEach((item) => {
        const { form1 } = item;
        if ((form1.planEndTime && !form1.planPersonId) || (form1.planPersonId && !form1.planEndTime)) {
          validSku.push(item);
        }
      });
      if (!validSku.length) {
        return true;
      }
      this.$message.error('请至少将SKU的渲染填写完整。');
      return false;
    },
    confirm() {
      if (!this.checkValid()) {
        return false;
      }
      const params = [];
      this.skuList.forEach((item) => {
        if (item.isRenderStart != 1) {
          params.push({
            ...item.form1,
            spuId: this.spuInfo.dataId,
            skuId: item.skuId,
            skuCode: item.skuCode,
            planPersonId: item.form1.planPersonId && item.isRenderStart != 1 ? item.form1.planPersonId : '',
            planPerson: item.form1.planPersonId && item.isRenderStart != 1 ? this.userList.find((v) => v.userId == item.form1.planPersonId).userName : '',
            planEndTime: item.form1.planEndTime && item.isRenderStart != 1 ? moment(item.form1.planEndTime).format('YYYY-MM-DD') : '',
          });
        }
      });
      this.$q.newProduct.savePlan({ data: params }).then(({ success }) => {
        if (success) {
          this.$notify.success({
            title: '成功',
            message: '保存渲染计划成功',
          });
          this.updateVal();
          this.$emit('success');
        }
      });
    },
    // 业务
    // 取消关联
    handleTagClose(skuCode) {
      this.relationSku = this.relationSku.filter((v) => v !== skuCode);
      const currentForm = this.skuList.find((item) => item.skuCode === skuCode);
      if (currentForm) {
        const basicForm = {
          planEndTime: '',
          planPersonId: '',
        };
        currentForm.form1 = {
          ...basicForm,
          taskId: 111,
        };
      }
    },
    relationWithSku(sku) {
      if (!sku || !sku.selectedSku.length) {
        return;
      }
      // 不是第一次同步，需要弹框提醒
      // if(this.activeSku) {
      //   await this.$confirm('已有关联SKU，是否需要清空重新关联该SKU？', '提示')
      // }

      this.relationSku = [...sku.selectedSku];
      sku.selectedSku = [];

      this.activeSku = sku.skuCode;
      // 同步表单
      let mainSkuItem = this.skuList.find((v) => v.skuCode === this.activeSku);
      this.skuList.forEach((item) => {
        if (this.relationSku.includes(item.skuCode)) {
          // 直接引用同一个
          item.form1 = mainSkuItem.form1;
        }
      });
    },
    getSpuInfo() {
      const params = {
        data: {
          pageNum: 1,
          pageSize: 1,
          filterData: {
            spuCode: this.spuCode,
          },
        },
      };
      this.loading = true;
      return this.$q.newProduct
        .listPage(params)
        .then(({ data }) => {
          this.spuInfo = (data && data.records && data.records[0]) || {};
          if (this.spuInfo.skuList && this.spuInfo.skuList.length) {
            this.skuList = this.spuInfo.skuList.map((item) => {
              const basicForm = {
                planEndTime: item.planRenderEndTime,
                planPerson: item.renderPerson,
                planPersonId: item.renderPersonId,
              };
              return {
                isRenderStart: item.isRenderStart,
                skuId: item.dataId,
                skuCode: item.skuCode,
                skuName: item.skuName,
                selectedSku: [],
                form1: {
                  ...basicForm,
                  taskId: 111,
                },
              };
            });
          }
        })
        .catch(console.log)
        .finally(() => {
          console.log(this.skuList);
          this.loading = false;
        });
    },
    getSkuOptions(sku) {
      this.all = false;
      sku.selectedSku = [];
      this.skuOptions = this.skuList.filter((item) => item.skuCode !== sku.skuCode && item.isRenderStart != 1);
    },
    getUserList() {
      let data = {
        pageSize: 999999,
        pageNum: 1,
        reportCode: 'getUserInfoByName',
      };
      axios.post(`/ec-pc-api/custom/reports/data/getUserInfoByName`, data).then((res) => {
        if (res.code == 200) {
          this.userList = res.data.list;
        }
      });
    },
    edit() {
      this.editStatus = !this.editStatus;
      if (!this.editStatus) {
        this.$q.newProduct
          .renderTypeUpdate({ data: this.tableData })
          .then((res) => {
            if (res.code == 200) {
              this.$message.success('编辑成功');
              this.init2();
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((err) => {
            this.init2();
          });
      }
    },
    cancel() {
      this.editStatus = false;
      this.init2();
    },
    //渲染类型
    init2() {
      console.log(this.spuInfo);
      let data = { ...this.currencyForm };
      data.reportCode = 'newProductRenderPlan2TypeList';
      data.param = {
        spuId: this.spuId,
      };
      axios.post(`/ec-pc-api/custom/reports/data/newProductRenderPlan2TypeList`, data).then((res) => {
        if (res.code == 200) {
          this.tableData = res.data.list;
          this.computeSpanData(this.tableData);
        }
      });
    },

    // 遍历表格数据，计算合并行数据
    computeSpanData(list) {
      this.spanArr = [];
      list.forEach((item, index) => {
        this.recordSpanData(index, list);
      });
    },
    // 计算每一行的合并行数据
    recordSpanData(index, data) {
      if (index === 0) {
        this.spanArr.push(1);
        this.spanIndex = 0;
      } else {
        // 判断当前元素与上一个元素是否相同
        if (data[index].productCode === data[index - 1].productCode) {
          this.spanArr[this.spanIndex] += 1;
          this.spanArr.push(0);
        } else {
          this.spanArr.push(1);
          this.spanIndex = index;
        }
      }
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex > 1) {
        return {
          rowspan: this.spanArr[rowIndex],
          colspan: 1,
        };
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-dialog__content
  overflow-x hidden
.sku-item
  margin-bottom 10px
.sku-item-header
  margin-bottom 5px
  >>> .el-col
    line-height 24px
.sku-item-form
  >>> .el-form-item
    margin-bottom 10px
  .relation-sku
    margin-bottom 5px
    >>> .el-tag+.el-tag
      margin-left 5px
>>> .el-tag
  .el-tag__close
    background-color #0bb78e
    color #fff

.slidex-enter
  transform translateX(100px)
  opacity 0
.slidex-enter-active,.slidex-leave-active
  transition all linear .3s
  opacity 1
  position absolute
  >>> .el-button
    display inline-block
.slidex-leave-to
  transform translateX(-100px)
  opacity 0

.form-tag
  position relative
  top 6px

.tips
  font-size 14px
  margin-top 10px
  color #999
  span
    color #E63946
.same-plan-box
  display flex
  width 210px
  align-items center
  justify-content space-between
  >>> .el-button
    padding 7px 5px
    border-top-left-radius 0
    border-bottom-left-radius 0
  >>> .el-select__tags
    max-width 150px
  >>> .el-input
    .el-input__inner
      border-top-right-radius 0
      border-bottom-right-radius 0
      margin-right -1px
    .el-input__suffix
      right 0
      .el-input__icon
        width 20px

>>> .el-tabs__item
  height 30px
  line-height 30px

>>> .el-select__tags-text {
  display: inline-block;
  max-width: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
>>> .el-select .el-tag__close.el-icon-close {
  top: 0px;
  right: -4px
}
</style>
